import api from '@/api/index.js'

const inspector_team_members = {
  state: {
    loading: false,
    updating: false,
    data: [],
    error: null
  },

  mutations: {
    SET_INSPECTOR_TEAM_MEMBERS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_INSPECTOR_TEAM_MEMBERS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_INSPECTOR_TEAM_MEMBERS: (state, teams) => {
      state.data = teams
      state.loading = false;
    },
    SET_INSPECTOR_TEAM_MEMBERS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadInspectorTeamMembers({commit}, id) {
      commit('SET_INSPECTOR_TEAM_MEMBERS_LOADING', true)
      commit('SET_INSPECTOR_TEAM_MEMBERS_ERROR', null)
      return api.get(`inspector-teams/${id}/members`)
        .then((response) => {
          commit('SET_INSPECTOR_TEAM_MEMBERS', response)
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAM_MEMBERS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAM_MEMBERS_LOADING', false)
        })
    },
    DeleteInspectorTeamMember({commit}, payload) {
      commit('SET_INSPECTOR_TEAM_MEMBERS_UPDATING', true);
      commit('SET_INSPECTOR_TEAM_MEMBERS_ERROR', null)
      return api.delete(`inspector-teams/${payload.id}/members/${payload.member_id}`)
        .then((response) => {
          commit('SET_INSPECTOR_TEAM_MEMBERS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAM_MEMBERS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAM_MEMBERS_UPDATING', false);
        })
    }
  }
}

export default inspector_team_members
